"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _misc = require("../../misc");
var _button = require("../../button");
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Placeholder = function Placeholder(_ref) {
  var label = _ref.label,
    disabled = _ref.disabled,
    createInitialFormula = _ref.createInitialFormula,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/_react["default"].createElement(_misc.Paragraph, {
    "data-testid": dataTestId
  }, (0, _utils.split)(label, '%').map(function (item, index) {
    return R.prop(index, _constants.extendedPlaceholdersTypeMap) ? /*#__PURE__*/_react["default"].createElement(_button.Button, {
      disabled: disabled,
      key: item,
      action: function action() {
        return createInitialFormula(_objectSpread({}, R.prop(index, _constants.extendedPlaceholdersTypeMap)));
      },
      variant: "naked",
      className: "placeholder-cta formula-".concat(R.path([index, 'type'], _constants.extendedPlaceholdersTypeMap), "-button")
    }, item) : item;
  }));
};
Placeholder.defaultProps = {
  disabled: false,
  dataTestId: 'placeholder-wrapper'
};
Placeholder.propTypes = {
  createInitialFormula: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Placeholder;